import PropTypes from "prop-types";
import { apiClient, getErrorMessage } from "../../shared";
import { ExpenseCategoryFormDialog } from "../expense-category-form-dialog";
import { useSnackbar } from "../../ui";

import { Button } from "@mui/material";

export const AddExpenseCategoryFormDialog = ({
  isOpen,
  onClose,
  onSubmitted,
}) => {
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async ({ name, status, chartOfAccountId }) => {
    try {
      await apiClient.post("expense-categories", {
        name,
        status,
        chartOfAccountId,
      });

      onSubmitted();
      onClose();
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal menambahkan kategori biaya"));

      throw error;
    }
  };

  return (
    <ExpenseCategoryFormDialog
      isOpen={isOpen}
      onClose={onClose}
      dialogTitle="Tambah Kategori Biaya"
      onSubmit={handleSubmit}
      renderDialogActionsChildren={({ isLoading }) => (
        <Button loading={isLoading} variant="contained" type="submit">
          Tambah
        </Button>
      )}
    />
  );
};

AddExpenseCategoryFormDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmitted: PropTypes.func.isRequired,
};
